<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from '@/i18n/index.ts';
import { formatDocumentTitle, PRODUCT_NAME } from '@/utils/brand.ts';

const route = useRoute();
const announcement = ref('');
const { t } = useI18n();

function routeName() {
  return document.querySelector('h1')?.textContent?.trim() || PRODUCT_NAME;
}

watch(
  () => route.path,
  async () => {
    await nextTick();
    const name = routeName();
    if (!document.documentElement.hasAttribute('data-vennevent-public-metadata')) document.title = formatDocumentTitle(name);
    announcement.value = t('accessibility.pageLoaded', { name });

    const main = document.querySelector<HTMLElement>('main');
    main?.focus({ preventScroll: true });
  },
  { immediate: true },
);
</script>

<template>
  <div
    aria-atomic="true"
    aria-live="polite"
    class="sr-only"
  >
    {{ announcement }}
  </div>
</template>
